import {AxiosRequestConfig} from 'axios';
import request from '../../../axios';

export const getPlanTransAction = async (
  params: IGetPlanPaymentLoadingProps,
) => {
  const {data}: {data: IGetPlanPaymentLoadingData} = await request.get(
    `/api/v2/subscription/transaction-storeplan`,
    {
      params: {
        ...params,
      },
    } as AxiosRequestConfig,
  );
  return data;
};
